interface Props {
    color?: string;
}

const ArcInverted = ({ color = 'black' }: Props) => {
    return (
        <svg
            width="100%"
            viewBox="0 0 500 30"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path fill={color} d="M0 0C0 0 120 29.5 250 29.5C380 29.5 500 0 500 0V30H0V0Z" />
        </svg>

    )
}

export default ArcInverted;
